import ChakraUiProvider from "infra/packages/@chakra-ui";
import { QueryClientProvider } from "react-query";
import GlobalStyle from "./styles/global";
import Pages from "./ui/pages/index";
import ScrollToTop from "ui/components/ScroolToTop";
import "react-datepicker/dist/react-datepicker.css";
import { queryClient } from "infra/packages/react-query";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ChakraUiProvider>
        <ScrollToTop />
        <TagTracker />
        <Pages />
        <GlobalStyle />
      </ChakraUiProvider>
    </QueryClientProvider>
  );
}

export function TagTracker() {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tag = params.get("tag");

    if (tag) {
      localStorage.setItem("crm_tag", tag);
    }
  }, [location.search]);

  return null;
}
